import React from "react";
import "./index.css";

const Buscador = (props) => {
  const {onChange} = props;
  return (
    <div className="Buscador">
      <input type="text" name="pais" onKeyPress={onChange} placeholder="Buscar"/>
    </div>
  );
};

export default Buscador;
